import { FeatherModule } from 'angular-feather';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output, TemplateRef } from '@angular/core';

@Component({
  selector: 'lib-button',
  imports: [FeatherModule, CommonModule, NgTemplateOutlet],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  readonly type = input<'button' | 'submit'>('button');
  readonly variant = input<'contained' | 'outlined' | 'text'>('outlined');
  readonly color = input<'default' | 'danger'>('default');
  readonly icon = input<string>('');
  readonly customIcon = input<TemplateRef<unknown> | null>(null);
  readonly iconPosition = input<'left' | 'right'>('left');
  readonly isLoading = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly size = input<'small' | 'medium' | 'large'>('medium');
  readonly fullWidth = input<boolean>(false);
  readonly rounded = input<boolean>(false);
  readonly noHover = input<boolean>(false);
  /** Renders a link that opens in a new tab instead of a button. */
  readonly externalHref = input<string | null>(null);

  readonly clicked = output<void>();

  readonly classes = computed(() => [
    'btn',
    'btn-' + this.variant(),
    'btn-' + this.size(),
    this.color() !== 'default' ? 'btn-color-' + this.color() : '',
    this.fullWidth() ? 'btn-full-width' : '',
    this.isLoading() ? 'btn-loading' : '',
    this.rounded() ? 'btn-rounded' : '',
    this.noHover() ? 'btn-no-hover' : '',
  ]);

  onButtonClick() {
    if (!this.disabled() && !this.isLoading()) {
      this.clicked.emit();
    }
  }
}
